import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { validate } from "../../../../../../utils/functions"
import { ArrowUpIcon } from "../../../../../../icons/svg/iconArrowUp"
import { ArrowDownIcon } from "../../../../../../icons/svg/iconArrowDown"
import { loadTexts } from "../../../../../../utils/i18n"

export function CustomTooltip(props) {
  const intlTooltipVariationEvolution = loadTexts("reports_general_view")
    .reportAmbassador.engagementMeasurement.widgetResume
    .tooltipVariationEvolution
  let payload = {}
  let variationKey = null
  let levelKey = null
  if (validate.exist(props.element) && props.element.active) {
    if (
      validate.exist(props.element.payload) &&
      props.element.payload.length > 0
    ) {
      payload = props.element.payload[0].payload
    }
  }
  if (
    validate.exist(props.lineActive) &&
    validate.exist(props.lineActive.dataKey)
  ) {
    variationKey = `${props.lineActive.dataKey}_variation`
    levelKey = `${props.lineActive.dataKey}_level`
  }

  return (
    <div className="tooltipEvolution">
      <div className="tooltipEvolution-Title">
        <span>{payload.name_measure}</span>
      </div>
      {variationKey !== null && payload[variationKey] !== null && (
        <div className="tooltipEvolution-Content">
          <span className="message">{intlTooltipVariationEvolution}</span>
          <span
            className="variation"
            style={{
              color:
                payload[levelKey] === "up"
                  ? " #55C8AE"
                  : payload[levelKey] === "down"
                  ? "#E37879"
                  : "#4F4F4F",
              marginLeft: 4,
            }}>
            {`${payload[variationKey] || 0}%`}
          </span>
          {payload[levelKey] === "up" ? (
            <ArrowUpIcon
              style={{ marginLeft: 2, height: "7.5px", paddingTop: "2px" }}
            />
          ) : payload[levelKey] === "down" ? (
            <ArrowDownIcon
              style={{ marginLeft: 2, height: "7.5px", paddingTop: "2px" }}
            />
          ) : null}
        </div>
      )}
    </div>
  )
}

CustomTooltip.propTypes = {
  element: PropTypes.object,
  measureGeneral: PropTypes.object,
}

export default CustomTooltip
